import { getAxiosClient } from "../../axios-client";
import { PostWarehouseAddRequestBod, PostWarehousesAddResponse } from "./types";

const axiosClient = getAxiosClient();
export const postWarehouseAdd = async (body: PostWarehouseAddRequestBod) => {
  return await axiosClient.ax.post<PostWarehousesAddResponse>(
    "/Warehouses/Add",
    body
  );
};




